import React from 'react';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45707755323553:1';
export function FinalCTA() {
  return <section className="w-full bg-[#3D2B1F] py-20 px-4" data-id="element-102">
      <div className="max-w-3xl mx-auto text-center" data-id="element-103">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#FDF8F3] mb-6" data-id="element-104">
          🌿 Criar con respeto no debería doler
        </h2>
        <p className="text-lg text-[#C4B89C] mb-10" data-id="element-105">
          No necesitás ser perfecto/a. Necesitás claridad, herramientas y
          acompañamiento.
        </p>

        <div className="mb-8" data-id="element-106">
          <span className="inline-block bg-[#C4645A] text-white text-sm font-bold px-4 py-2 rounded-full animate-pulse" data-id="element-107">
            ⏳ OFERTA POR TIEMPO LIMITADO 🔥 BONOS GRATIS SOLO HOY – QUEDAN 3
            CUPOS
          </span>
        </div>

        <a href={CHECKOUT_URL} className="inline-block bg-[#8B9E7E] hover:bg-[#6B8068] text-white text-xl font-bold py-5 px-10 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:scale-105" data-id="element-108">
          👉 SÍ, QUIERO ACCEDER A CRIANZA MONTESSORI EN CASA AHORA
        </a>
      </div>
    </section>;
}